/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'busbud': {
    width: 2730.667,
    height: 2730.667,
    viewBox: '0 0 2048 2048',
    data: '<path pid="0" d="M0 1024v1024h946.7l-.8-4.3c-.4-2.3-.8-96.1-.9-208.3v-204.1l-6.2-3.7c-15.3-9-35.8-25.4-59.3-47.6-23.4-22.2-409.2-407.8-423.4-423.3-32.7-35.6-47.5-57.7-55.5-82.7-10.2-31.7-11.4-66.6-3.2-98.8 7.8-31 22.3-54.3 57.8-92.9 19.6-21.2 419.7-420.6 435.3-434.4 26.8-23.8 43.9-36.2 61-44.4 40-19.1 93.6-20.6 136-3.8 24.5 9.7 45.8 25.3 85 62.3 29.6 27.9 418.6 417.7 429.6 430.5 27 31.2 39 50.5 46.2 74.5 5.8 19 7.1 28.8 7.1 52 .1 31.1-4 49.6-16.4 74.5-10.2 20.5-22.6 36.9-50.2 66.6-15 16-399.4 400.1-420.3 419.9-18.9 17.9-38.9 34.3-52.7 43.2l-12.7 8.3-.1 204c0 112.2-.5 205.9-.9 208.3l-.8 4.2H2048V0H0v1024z"/>'
  }
})
